// import $ from 'jquery';
import tippy from "tippy.js";
tippy(document.querySelectorAll(".tooltip"), {
  animation: "scale",
  theme: "telecube"
});

tippy(document.querySelectorAll(".areas-api__item-status--success"), {
  animation: "scale",
  theme: "telecube--success",
  content:
    "Wystarczy podać adres siedziby Twojej firmy.",
  maxWidth: 340
});

tippy(document.querySelectorAll(".areas-api__item-status--warning"), {
  animation: "scale",
  theme: "telecube--warning",
  content:
    "Może nastąpić konieczność przedstawienia dodatkowych, obligatoryjnych dokumentów przed aktywacją numeru. Sprawdź dokładne wymogi w danym kraju i strefie korzystając z wyszukiwarki nad tabelką.",
  maxWidth: 340
});

tippy(document.querySelectorAll(".areas-api__item-status--error"), {
  animation: "scale",
  theme: "telecube--error",
  content:
    "Należy posiadać siedzibę lub filię w danym kraju. Sprawdź dokładne wymogi w danym kraju i strefie korzystając z wyszukiwarki nad tabelką.",
  maxWidth: 340
});
